import { createFileRoute } from "@tanstack/react-router";

import { sdk } from "@/api/sdk";
import { PortalHead, PortalPage } from "@/features/portal/components/portal-chrome";
import { CoachesHero, CoachesShowcase } from "@/features/portal/modules/coaches-page/coaches-page";
import { CoachDirectory } from "@/features/portal/modules/coaches/coach-directory";
import { DIRECTORY_DAYS } from "@/features/portal/modules/coaches/directory-days";
import { ForCoaches } from "@/features/portal/modules/for-coaches/for-coaches";
import { pageMeta } from "@/lib/seo";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/coaches/")({
  head: () => ({ meta: pageMeta({ title: m.portal_coaches_title(), description: m.seo_coaches_description() }) }),
  // Read before the page draws, as on the front page; a directory that cannot be reached shows
  // the empty page rather than failing the route.
  loader: async () => {
    const { data } = await sdk.t.bookable.$get.setQueryParams({ days: String(DIRECTORY_DAYS) }).send();
    return { crumb: m.portal_nav_coaches(), trainers: data ?? [] };
  },
  component: CoachesPage,
});

/**
 * Everybody taking bookings, on a page of its own: the hero with the directory drawn as a map, the
 * real list with this week's open times, then why booking here beats a message.
 */
function CoachesPage() {
  const { trainers } = Route.useLoaderData();

  return (
    <PortalPage
      head={
        <PortalHead>
          <CoachesHero />
        </PortalHead>
      }
    >
      <CoachDirectory trainers={trainers} standalone />
      <CoachesShowcase />
      <ForCoaches />
    </PortalPage>
  );
}
